import { configureStore } from '@reduxjs/toolkit'
import userDataReducer from './dashboard/reducer'

const store = configureStore({
  reducer: {
    dashboard: userDataReducer
  }
})

export { store }

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
